export default {
  on: true,
  cache: false,
  auth: true,
  intercept: false,

  title: '发货清单-新增',
} as TCommon.RouteConfig
